var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37712 11.3356C9.39765 8.80384 7.22289 6.73801 4.54686 6.73801C3.75173 6.73801 3.11115 6.10084 3.16754 5.33873C3.21514 4.69542 3.76692 4.17436 4.44804 4.12941C4.97943 4.09434 5.45344 4.3447 5.71521 4.73427C6.00282 5.16229 6.49174 5.43206 7.02851 5.43206H7.09084C8.31357 5.43206 9.06082 4.16477 8.41834 3.18225C7.79481 2.22869 6.78751 1.52177 5.60152 1.25471V0.996094C5.60152 0.445984 5.1293 0 4.54683 0C3.96436 0 3.49214 0.445984 3.49214 0.996094V1.25475C1.49179 1.70511 -3.51556e-05 3.40694 6.21356e-10 5.43213C3.51569e-05 7.79998 2.0397 9.72632 4.54683 9.72632C5.50797 9.72632 6.28161 10.4988 6.20838 11.4209C6.14725 12.1903 5.48958 12.8115 4.67487 12.8693C3.99449 12.9175 3.39107 12.5774 3.08767 12.0596C2.81145 11.5881 2.28101 11.3001 1.71049 11.3001C0.503648 11.3001 -0.260965 12.5264 0.328465 13.521C0.990035 14.6374 2.13423 15.4651 3.49214 15.7519V16.0039C3.49214 16.554 3.96436 17 4.54683 17C5.1293 17 5.60152 16.554 5.60152 16.0039V15.7516C7.74394 15.2966 9.35968 13.4876 9.37712 11.3356Z",
    fill: "#7E7E8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.90716e7a6e54f5c1bf5338689f479737.svg";
export { ForwardRef as ReactComponent };